import Laudo from './Laudo';
export default Laudo;
